import { useEffect } from "react";
import axios from "axios";
import Footer from "../components/home/footer";
import Header from "../components/home/header";
import Paymentsuccess from "../assets/payment/payment.gif";

const Success = () => {

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));

    if (user?.email) {
      const repsonse =axios.post("https://ankit1.jaskart.com/cart/delete-by-email", {
        email: user.email,
      })
      .catch(err => {
        console.error("Clear cart failed:", err);
      });
    }
  }, []);

  return (
    <>
      <Header />
      <div className="container-fluid">
        <div
          className="container text-center d-flex justify-content-center align-items-center"
          style={{ height: "90vh" }}
        >
          <div>
            <img
              src={Paymentsuccess}
              alt="payment success"
              style={{ width: "400px", height: "400px" }}
            />
            <p style={{ fontWeight: 600 }}>Payment success</p>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Success;
